import { useQuery } from "@tanstack/react-query";
import {
	getBilletsProcessData,
	getBilletsProcessPickers,
	type GetBilletsProcessDataParams,
	type GetBilletsProcessPickersParams,
} from "../repositories/BilletsProcessDataRepository";

type UseBilletsProcessDataParams = Omit<
	GetBilletsProcessDataParams,
	"signal"
> & {
	enabled?: boolean;
};

export const useBilletsProcessData = ({
	start,
	end,
	variableName,
	crewId = null,
	productSizeId = null,
	productTypeId = null,
	enabled = true,
}: UseBilletsProcessDataParams) => {
	return useQuery({
		queryKey: [
			"billetsProcessData",
			start,
			end,
			variableName,
			crewId,
			productSizeId,
			productTypeId,
		],
		queryFn: ({ signal }) =>
			getBilletsProcessData({
				start,
				end,
				variableName,
				crewId,
				productSizeId,
				productTypeId,
				signal,
			}),
		enabled: enabled && !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};

type UseBilletsProcessPickersParams = Omit<
	GetBilletsProcessPickersParams,
	"signal"
>;

export const useBilletsProcessPickers = ({
	start,
	end,
}: UseBilletsProcessPickersParams) => {
	return useQuery({
		queryKey: ["billetsProcessPickers", start, end],
		queryFn: ({ signal }) => getBilletsProcessPickers({ start, end, signal }),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
